// Upload and AI-index state for a file, as tones rather than class names.
//
// Three copies of these maps used to live side by side — the document library, the asset media
// panel and the AI indexing panel each had their own — and they had already drifted: the same
// "failed" was `text-danger` in two of them and `text-danger-emphasis` in the third, and
// `processing` was `text-primary` everywhere, which is 2.6:1 on its own fill.
export function uploadStatus(status) {
  if (status === 'ready') return null;
  if (status === 'pending_upload') return { label: 'Uploading…', tone: 'progress' };
  if (status === 'failed') return { label: 'Upload failed', tone: 'danger' };
  return { label: status, tone: 'neutral' };
}

const INDEX_STATES = {
  not_applicable: { label: 'N/A', tone: 'quiet' },
  pending: { label: 'Pending', tone: 'warning' },
  processing: { label: 'Indexing', tone: 'progress' },
  ready: { label: 'Ready', tone: 'success' },
  failed: { label: 'Failed', tone: 'danger' },
};

/** For the indexing panel, where the whole column is about the index. */
export function knowledgeIndexStatus(status) {
  return INDEX_STATES[status] || { label: status, tone: 'neutral' };
}

/**
 * For a file row, where the index state is one fact among several and has to say what it is
 * about. Only files shared with field engineers are indexed at all, so the rest show nothing.
 */
export function knowledgeIndexFileStatus(item) {
  if (!item.visible_to_field_engineers) return null;
  const state = INDEX_STATES[item.knowledge_index_status];
  if (!state) return null;
  const labels = {
    not_applicable: null,
    pending: 'AI index pending',
    processing: 'AI indexing…',
    ready: 'AI ready',
    failed: 'AI index failed',
  };
  const label = labels[item.knowledge_index_status];
  return label ? { label, tone: state.tone } : null;
}
